import * as types from './types';

const INITIAL_STATE = {};

function _setPartnerDetails(state, action) {
    const {
        payload,
    } = action;

    return {
        ...state,
        affiliateId: payload.affiliateId,
        trackingId: payload.trackingId,
    };
}

const handlers = {
    [types.SET_PARTNER_DETAILS]: _setPartnerDetails,
};

function reducer(state = INITIAL_STATE, action) {
    if (handlers.hasOwnProperty(action.type)) {
        const handler = handlers[action.type];
        return handler(state, action);
    }

    return state;
}

export default reducer;
